import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { UndeliveredAwbDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

export const undeliveredAwbTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "AWB",
    value: "doc_trans",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Pct. preluare",
    value: "pctpreluare",
    minW: 125,
  },
  {
    label: "Pct. livrare",
    value: "pctlivrare",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Adresa",
    value: "adresa",
    minW: 125,
  },
  {
    label: "Nod-Destinatie",
    value: "nodDestinatie",
    minW: 125,
  },
  {
    label: "Ruta/Ruta transferata",
    value: "route",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
  },
  {
    label: "Tip colete",
    value: "tip_colete",
    minW: 125,
  },
  {
    label: "Data crearii",
    value: "data_crearii",
    minW: 125,
  },
];

export const getUndeliveredAwbTableData = (
  data: UndeliveredAwbDataInterface[],
): TableData[] =>
  data.map((item) => {
    const isColdBox = item.tip_colete.some((tip) => tip.tip_ambalaj === 75);

    const coldBoxStyle = {
      color: isColdBox ? "#90D5FF" : "black",
    };

    return {
      id: item.id_doctrans,
      crudData: item,
      data: [
        {
          title: item.doc_trans,
          titleStyle: coldBoxStyle,
        },
        {
          title: item.pctpreluare,
        },
        {
          title: item.pctlivrare,
        },
        {
          title: item.adresa,
        },
        {
          title: item.nodDestinatie,
        },
        {
          badges: [
            {
              badgeText: item.ruta,
              badgeColor: "light-info",
            },
            {
              badgeText: item.rutaTransferata ?? "-",
              badgeColor: "light-success",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.denumireStatus ?? "-",
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: item.tip_colete.map((tip) => {
            return {
              badgeText: `${tip.denumire} x ${tip.count_tip_ambalaj}`,
              badgeColor: "primary",
            };
          }),
        },
        {
          badges: [
            {
              badgeText: item.data_crearii
                ? getDateAndTime(item.data_crearii)
                : "-",
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
